import type { FC } from 'react';

const COLORS: Record<string, { bg: string; fg: string }> = {
  // Per-review colors, keyed by the review number (1-4). The legacy U/A/S/F
  // keys are kept so other usages (topbar pills, dashboard) still resolve.
  '1': { bg: '#fde8e7', fg: '#c83e39' },
  '2': { bg: '#e6f5ee', fg: '#1b774d' },
  '3': { bg: '#f0e9fc', fg: '#7a5cf5' },
  '4': { bg: '#fff1e0', fg: '#c45e00' },
  U: { bg: '#fde8e7', fg: '#c83e39' },
  A: { bg: '#e6f5ee', fg: '#1b774d' },
  S: { bg: '#f0e9fc', fg: '#7a5cf5' },
  F: { bg: '#fff1e0', fg: '#c45e00' },
};

/**
 * Colored IPOP chip from the "Ipop Tools — Improved" design, used to tag the
 * four review nav items. Renders the given label (review number 1-4).
 */
export const IpopLetter: FC<{ letter: string; size?: number }> = ({ letter, size = 20 }) => {
  const c = COLORS[letter] || { bg: '#f3f4f7', fg: '#5b6072' };
  return (
    <span
      style={{
        width: size,
        height: size,
        borderRadius: 6,
        background: c.bg,
        color: c.fg,
        display: 'grid',
        placeItems: 'center',
        fontWeight: 800,
        fontSize: size * 0.5,
        letterSpacing: '-0.02em',
        flexShrink: 0,
      }}
    >
      {letter}
    </span>
  );
};
